/**
 * Auto-generated theme configuration
 * DO NOT EDIT MANUALLY - This file is generated automatically
 *
 * To add a new customer theme:
 * 1. Create a folder: src/assets/themes/customers/{customer-id}/
 * 2. Add {customer-id}-light.scss and {customer-id}-dark.scss files
 * 3. Run: npm run generate-themes (or it runs automatically before build/serve)
 */

export interface ThemePackage {
  id: string;
  name: string;
  description?: string;
}

export const DEFAULT_THEME: ThemePackage = {
  id: 'default',
  name: 'Default',
  description: 'Default theme package'
};

export const CUSTOMER_THEMES: ThemePackage[] = [
  {
    id: 'abcd',
    name: 'Abcd',
    description: 'Custom theme for Abcd'
  },
  {
    id: 'acme-corp',
    name: 'Acme Corp',
    description: 'Custom theme for Acme Corp'
  },
  {
    id: 'tech-startup',
    name: 'Tech Startup',
    description: 'Custom theme for Tech Startup'
  }
];

export const ALL_THEMES = [DEFAULT_THEME, ...CUSTOMER_THEMES];

export function getThemeById(id: string): ThemePackage | undefined {
  return ALL_THEMES.find((theme) => theme.id === id);
}
